import { english } from './english';
import textContextUtils from './utils';

const textContext: { [key: string]: any } = {
  english,
  utils: textContextUtils,
};

export default textContext;
